import React from 'react';
import Spinner from '@/components/Spinner';

export default function FullScreenSpinner() {
  return (
    <div className="fixed inset-0 bg-[#F5F5F5] flex items-center justify-center p-4">
      <div className="text-center">
        <Spinner className='w-12 h-12 mx-auto !border-t-primary' size={40} />
      </div>
    </div>
  );
}
